export default "__VITE_ASSET__DOlEjV3u__"